import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { ClinicalCategoryDetailsComponent } from './detail/clinicalcategory-detail.component';
import { ClinicalCategoryService } from './clinicalCategory.service';
import { PaginationResult } from 'src/app/models/common.response';
import { debounceTime, distinctUntilChanged, finalize, Observable, Subject, switchMap, takeUntil } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { DeleteDialog } from '../../dialogs/delete.component';
import { ToastrService } from 'ngx-toastr';
import { Router, RouterModule } from '@angular/router';
import { AppBreadcrumbComponent } from "../../../layouts/full/shared/breadcrumb/breadcrumb.component";
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PaginationRequest } from 'src/app/models/common.request';
import { IClinicalCategory } from './iclinical-category';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';
import { PAGE_SIZE_OPTIONS } from 'src/app/common/constant/constants.type';


@Component({
  selector: 'app-clinical-category',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    RouterModule,
    AppBreadcrumbComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  templateUrl: './clinical-category.component.html',
  styleUrl: './clinical-category.component.scss'
})
export class ClicnicalCategoryComponent implements OnInit, AfterViewInit {
  dataSource = new MatTableDataSource<IClinicalCategory>();
  displayedColumns: string[] = [
    'name',
    'categorytype',
    'description',
    'item',
    'action',
  ];

  pagination: PaginationResult;
  categorycount: number = 0;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  isLoading: boolean = false;
  categorydata: IClinicalCategory[];
  searchCategory: FormControl = new FormControl();
  pageSizeOptions = PAGE_SIZE_OPTIONS;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator =
    Object.create(null);
  categories$: Observable<IClinicalCategory[]>;

  constructor(
    private dialog: MatDialog,
    private _categoryService: ClinicalCategoryService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private _router: Router,
    private translate: TranslateService,
    private translationUtils: TranslationUtils
  ) { }


  ngOnInit(): void {
    this._categoryService.pagination$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((pagination: PaginationResult | null) => {
        if (pagination) {
          this.pagination = pagination;
          this.categorycount = this.pagination.rowCount;
        }
      });



    this._categoryService.categories$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((data) => {
        this.dataSource.data = data;
        this.categorydata = data;
      });

    this.searchCategory.valueChanges.pipe(
      takeUntil(this._unsubscribeAll),
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((query) => {
        this.isLoading = true;
        return this._categoryService.getCategory({
          pageNumber: 0,
          pageSize: this.pagination.pageSize,
          isDescending: false,
          searchValue: query || ''
        }).pipe(
          finalize(() => (this.isLoading = false))
        );
      })
    ).subscribe((response) => { });
    // this.categories$ = this._categoryService.categories$;

  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  onAddCategory() {
    this.dialog.open(ClinicalCategoryDetailsComponent, {
      autoFocus: false,
      width: '700px',
      height: 'auto',
      disableClose: true,
    }).afterClosed().subscribe((result) => {
      if (result) {
        this.refreshCategories();
      }
    });
  }

  onClinicalCategoryDelete(id: number) {
    const confirmation = this.dialog.open(DeleteDialog, {
      width: 'auto',
      enterAnimationDuration: '300ms',
      exitAnimationDuration: '300ms',
      disableClose: true,
      data: { message: this.translate.instant('DELETE_DIALOG') + ' ' + this.translate.instant('ENTITY.CATEGORY') + ' ?' }
    })
    confirmation.afterClosed().subscribe((result) => {
      if (result === "confirm") {
        this._categoryService.deletecategory(id).subscribe((response) => {
          if (response.isSuccess) {
            this.refreshCategories();
            this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.DELETE', this.translate.instant('ENTITY.CATEGORY')));
          }
          else {
            const allErrors = Object.values(response.errors).flat();
            this.toastr.error(allErrors.join("\n"));

          }
        })
      }
    });
  }

  onClinicalCategoryEdit(data: IClinicalCategory): void {
    this.dialog.open(ClinicalCategoryDetailsComponent, {
      autoFocus: false,
      width: '700px',
      height: 'auto',
      disableClose: true,
      data: {
        category: data,
        isEdit: true
      }
    }).afterClosed().subscribe((result) => {
      if (result) {
        this.refreshCategories();
      }

    });
  }

  private refreshCategories() {
    const globalSearchValue = this.searchCategory?.value?.trim();
    const requestPayload: PaginationRequest = {
      pageNumber: 0,
      pageSize: this.pagination?.pageSize || 100,
      isDescending: false
    };

    if (globalSearchValue) {
      requestPayload.searchValue = globalSearchValue;
    } else {
      requestPayload.pageNumber = this.pagination?.currentPage || 0;
    }

    this._categoryService.getCategory(requestPayload)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response) => {
        if (response && response.result) {
          const categories = response.result.clinicalCategories;
          this.categorydata = categories;
          if (!this.dataSource) {
            this.dataSource = new MatTableDataSource(categories);
          } else {
            this.dataSource.data = categories;
          }
          this.dataSource.paginator = this.paginator;
          this.categorycount = response.result.pagination.rowCount;
          this.pagination = response.result.pagination;
        }
      });
  }

  onGoClinicalItem(categoryid: number) {
    this._router.navigate(['/clinical/category', categoryid, 'clinicalitem'])
  }

}
